<template>
  <div class="main">
    <div class="navbar">
      <div class="left" @click="goBack">
        <img src="@/assets/groupRob/back-black.png" alt="" class="back" />
      </div>
      <div class="title">订单详情</div>
      <div class="right"></div>
    </div>
    <div class="body" v-if="D.panic_order">
      <div class="status" v-if="D._status == 1">
        <span class="label">已提交报名，等待买家付款</span>
        <span class="desc">剩余{{ D._text }}订单自动关闭</span>
      </div>
      <div class="status" v-if="D._status == 2">
        <span class="label">待抢购</span>
        <span class="desc">{{ D._text }}开始抢购</span>
      </div>
      <div class="status" v-if="D._status == 3">
        <span class="label">抢购中</span>
        <span class="desc">剩余{{ D._text }}结束</span>
      </div>
      <div class="status" v-if="D._status == 4">
        <span class="label">已抢到</span>
        <span class="desc">即将为您发货</span>
      </div>
      <div class="status" v-if="D._status == 5">
        <span class="label">待退款/退款中</span>
        <span class="desc">订单金额预计在0-3个工作日退回</span>
      </div>
      <div class="status" v-if="D._status == 6">
        <span class="label">支付超时</span>
        <span class="desc">订单已关闭</span>
      </div>
      <div class="status" v-if="D._status == 7">
        <span class="label">退款成功</span>
        <span v-if="D.after_sale" class="desc">{{
          D.after_sale.payment_date
        }}</span>
      </div>
      <div
        v-if="D._status == 5 || D._status == 7"
        class="refund"
        :class="{ active: D._status == 7 }"
      >
        <div class="item">
          <span v-if="D._status == 7">退款金额</span>
          <span v-else>预计退款金额</span>
          <span class="value">¥{{ D.order.order_amount }}</span>
        </div>
        <div class="item">
          <span v-if="D._status == 7">赠送积分</span>
          <span v-else>预计赠送积分</span>
          <span class="value">{{ D.panic_order.refund_credits }}</span>
        </div>
      </div>
      <div class="location">
        <img src="@/assets/groupRob/loc.png" alt="" class="icon" />
        <div v-if="D.order.delivery_address" class="info">
          <div class="user">
            <span>{{ D.order.delivery_address.consignee }}</span>
            <span class="phone">{{
              D.order.delivery_address.consignee_mobile
            }}</span>
          </div>
          <div class="addr">
            {{ D.order.delivery_address.address_name }}
            {{ D.order.delivery_address.address }}
          </div>
        </div>
      </div>
      <div class="goods">
        <div
          v-if="D.order_goods"
          class="block"
          @click="toGoods(D.order_goods.real_goods_id)"
        >
          <img :src="D.order_goods.sku_image" alt="" class="icon" />
          <div class="info">
            <div class="top">
              <span class="label">{{ D.order_goods.goods_name }}</span>
              <span class="money">¥{{ D.order_goods.sale_price }}</span>
            </div>
            <div class="spec">{{ D.order_goods.specification_name }}</div>
            <div class="count">x{{ D.order_goods.quantity }}</div>
          </div>
        </div>
        <div class="item">
          <span class="label">商品金额</span>
          <span class="value">¥{{ D.order.goods_amount }}</span>
        </div>
        <div class="item">
          <span class="label">运费</span>
          <span class="value">¥{{ D.order.postage }}</span>
        </div>
        <div class="total">
          <span class="label">合计</span>
          <span>¥</span>
          <span class="large">{{ D._price_l }}</span>
          <span>.{{ D._price_s }}</span>
        </div>
      </div>
      <div class="order">
        <div class="title">订单信息</div>
        <div
          v-if="
            D.panic_order &&
              !(D.panic_order.status == 5 || D.panic_order.status == 7)
          "
          class="credits"
        >
          <span>预计赠送积分：</span>
          <span class="active">{{ D.panic_order.settle_credits }}</span>
        </div>
        <div class="line"></div>
        <div class="item">
          <span class="label">订单编号：</span>
          <span class="value">{{ D.order.ordersn }}</span>
          <div class="copy" @click="copy(D.order.ordersn)">复制</div>
        </div>
        <div class="item">
          <span class="label">下单时间：</span>
          <span class="value">{{ D.panic_order.created_at }}</span>
        </div>
      </div>
    </div>
    <div
      class="footer"
      v-if="D._status == 1 || D._status == 3 || D._status == 4"
    >
      <div v-if="D._status == 1" class="btn" @click="toCancel">取消订单</div>
      <div v-if="D._status == 1" class="btn active" @click="toPay">
        立即付款
      </div>
      <div
        v-if="D._status == 3"
        class="btn active"
        @click="rushBuy(D.panic_order.id)"
      >
        立即抢购
      </div>
      <div v-if="D._status == 4" class="btn active" @click="toDetail">
        查看详情
      </div>
    </div>

    <Modal v-model="modelType" @close="onClose" />
  </div>
</template>

<script>
import mixin from "./mixin";
import Utils from "@/providers/utils";
import dsbridge from "dsbridge";
import { getTimestamp, getCountDown } from "./utils";
import Modal from "./modal.vue";
import { getQuery } from "./utils";

export default {
  components: {
    Modal,
  },
  mixins: [mixin],
  created() {
    this.fromApp = !!getQuery("fromapp", location.href);
    this.ordersn = this.$route.params.ordersn;
    const ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
      this.client = "ios";
    } else if (/android/.test(ua)) {
      this.client = "android";
    }
    this.getOrder();
  },
  mounted() {
    window.setPay = this.setPay;
  },
  data() {
    return {
      ordersn: null,
      client: null,
      modelType: null,
      fromApp: false,
      D: {},
      pending: false,
    };
  },
  methods: {
    goBack() {
      if (this.fromApp) {
        this.params(null, null, "goBack");
      } else {
        this.$router.back();
      }
    },
    getOrder() {
      this.$api
        .post("onorder/member/order/panic-order-detail", {
          ordersn: this.ordersn,
        })
        .then((res) => {
          res._status = res.panic_order.status;
          if (res.order && res.order.order_amount) {
            const order_amount = res.order.order_amount.split(".");
            res._price_l = order_amount[0];
            res._price_s = order_amount[1] || "00";
          }
          // 待支付
          if (res._status == 1) {
            let _second =
              getTimestamp(res.panic_order.created_at) +
              30 * 60 * 1000 -
              getTimestamp();
            _second = Math.floor(_second / 1000);
            if (_second > 0) {
              res._second = _second;
              res._text = getCountDown(_second, "h时m分s秒");
              this.startCountDown();
            }
          }
          // 待抢购
          if (res._status == 2) {
            let _second =
              getTimestamp(res.order_goods.activity_main.activity_start_at) -
              getTimestamp();
            _second = Math.floor(_second / 1000);
            if (_second < 24 * 60 * 60 && _second > 0) {
              res._second = _second;
              res._text = getCountDown(_second, "h时m分s秒");
              this.startCountDown();
            } else {
              res._text = res.order_goods.activity_main.activity_start_at;
            }
          }
          // 抢购中
          if (res._status == 3) {
            let _second =
              getTimestamp(res.order_goods.activity_main.activity_end_at) -
              getTimestamp();
            _second = Math.floor(_second / 1000);
            if (_second > 0) {
              res._second = _second;
              res._text = getCountDown(_second, "h时m分s秒");
              this.startCountDown();
            }
          }
          this.D = res;
          console.log("订单详情", this.D);
        });
    },
    copy(e) {
      Utils.copy(e);
    },
    toCancel() {
      this.$api
        .post("order/member/order/cancel", { ordersn: this.D.order.ordersn })
        .then((res) => this.getOrder())
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    toPay() {
      let param = {
        actual_amount: this.D.order.actual_amount,
        order_amount: this.D.order.order_amount,
        ordersn: this.D.order.ordersn,
        order_type: "panic-buying",
      };
      if (this.client == "ios") {
        dsbridge.call("goPay", JSON.stringify(param), (v) => this.setPay(v));
      } else if (this.client == "android") {
        this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
      }
    },
    rushBuy(id) {
      if (this.pending) {
        return;
      }
      this.pending = true;
      this.$api
        .post("onorder/member/order/panic-buying", { id })
        .then((res) => {
          if (res.status) {
            this.modelType = "success";
          } else {
            this.modelType = "fail";
          }
        })
        .catch((err) => {
          if (err.code === 231904) {
            this.$toast("请重试");
          } else {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          }
        })
        .finally(() => (this.pending = false));
    },
    onClose() {
      this.getOrder();
      this.modelType = null;
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$toast("支付成功");
        this.getOrder();
      }
    },
    startCountDown() {
      this._timer && clearInterval(this._timer);
      this._timer = setInterval(() => {
        this.D._second--;
        this.D._text = getCountDown(this.D._second, "h时m分s秒");
        if (this.D._second <= 0) {
          clearInterval(this._timer);
          this.getOrder();
        }
      }, 1000);
    },
    toDetail() {
      this.params(this.D.order.ordersn, this.D.order.ordersn, "orderDetail");
    },
    toGoods(e) {
      this.params(e, e, "goBuy");
    },
  },
  beforeDestroy() {
    this._timer && clearInterval(this._timer);
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.main {
  height: 100%;
  background: #f5f6f7;
  font-size: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .navbar {
    height: calc(4.4rem + var(--status-height));
    display: flex;
    align-items: stretch;
    padding: var(--status-height) 1.2rem 0;

    .left,
    .right {
      flex: 0 0 8rem;
      max-width: 8rem;
      display: flex;
      align-items: center;

      .back {
        width: 1.8rem;
        height: 1.8rem;
      }
    }

    .right {
      justify-content: flex-end;
    }

    .title {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .body {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: auto;
    padding-bottom: 2rem;

    // 魅族手机高度塌陷
    * {
      flex-shrink: 0;
    }

    .status {
      display: flex;
      flex-direction: column;
      margin: 1.2rem 1.2rem 0;
      padding: 0 1.2rem;

      .label {
        font-size: 1.8rem;
      }

      .desc {
        margin-top: 0.2rem;
        color: #666666;
      }
    }

    .refund {
      margin: 1.2rem 1.2rem 0;
      padding: 1.5rem 1.2rem;
      border-radius: 0.6rem;
      background: #fff;
      font-size: 1.5rem;
      color: #999999;

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.9rem;

        &:first-of-type {
          margin: 0;
        }

        .value {
          font-weight: 700;
          color: #333333;
        }
      }

      &.active {
        background: #ff723b;
        color: #fff;

        .value {
          color: #fff;
        }
      }
    }

    .location {
      background: #fff;
      margin: 1.2rem 1.2rem 0;
      padding: 1.5rem 1rem;
      display: flex;
      align-items: center;
      border-radius: 0.5rem;

      .icon {
        flex: 0 0 2.6rem;
        height: 2.6rem;
        margin-right: 1.5rem;
      }

      .info {
        flex: 1;

        .user {
          font-size: 1.6rem;
          color: #333333;

          .phone {
            margin-left: 2rem;
          }
        }

        .addr {
          margin-top: 0.6rem;
          color: #999999;
          word-break: break-all;
        }
      }
    }

    .goods {
      background: #fff;
      margin: 1.2rem 1.2rem 0;
      padding: 1.2rem;
      border-radius: 0.8rem;

      .block {
        display: flex;

        .icon {
          width: 9.8rem;
          height: 9.8rem;
          border-radius: 0.6rem;
          margin-right: 1.2rem;
        }

        .info {
          flex: 1;
          overflow: hidden;

          .top {
            font-weight: 700;
            display: flex;

            .label {
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .money {
              margin-left: 1.7rem;
            }
          }

          .spec {
            margin-top: 0.6rem;
            color: #999999;
          }

          .count {
            text-align: right;
            color: #999999;
          }
        }
      }

      .item {
        margin-top: 1.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .label {
          color: #999999;
        }
      }

      .total {
        text-align: right;
        font-size: 1.3rem;
        color: #333333;
        margin-top: 1.6rem;
        font-weight: 700;

        .label {
          margin-right: 0.6rem;
          font-size: 1.5rem;
          color: #666666;
          font-weight: 400;
        }

        .large {
          font-size: 2rem;
        }
      }
    }

    .order {
      margin: 1.2rem 1.2rem 0;
      padding: 1.2rem;
      background: #fff;
      border-radius: 0.6rem;

      .title {
        font-weight: 700;
      }

      .credits {
        margin-top: 1.2rem;
        font-size: 1.3rem;
        color: #999999;

        .active {
          color: #f9591b;
        }
      }

      .line {
        height: 0.1rem;
        background: #e6e6e6;
        margin: 1.2rem 0;
      }

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.3rem;
        padding: 0.2rem 0;

        .label {
          color: #999999;
        }

        .value {
          flex: 1;
          margin-left: 2.8rem;
        }

        .copy {
          padding: 0.4rem 1.2rem;
          border: 0.1rem solid #f9591b;
          color: #f9591b;
          border-radius: 0.2rem;
        }
      }
    }
  }

  .footer {
    background: #fff;
    padding: 0.8rem 1.2rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .btn {
      height: 3.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #cccccc;
      border-radius: 1.6rem;
      color: #666666;
      padding: 0 1.2rem;
      margin-left: 1rem;

      &.active {
        border-color: #f9591b;
        color: #f9591b;
      }
    }
  }
}
</style>
